import { LandingCategory } from 'constants/enums';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { LandingPropsState } from './types';

const useLandingPropsStore = createWithEqualityFn<LandingPropsState>(
  set => ({
    isMobile: null,
    device: null,
    pending: false,
    category: LandingCategory.general,
    premiumPopupPackage: '',
    screenName: '',
    promoRequired: false,
    tags: '[]',
    setLandingProps: props => set(prev => ({ ...prev, ...props })),
    setDeviceProps: props => set(prev => ({ ...prev, ...props })),
  }),
  shallow,
);

export default useLandingPropsStore;
